import React from 'react';

const Card = ({ children, title, subtitle, icon, action, className = '', padding = true }) => {
  return (
    <div className={`bg-white rounded-3xl shadow-sm border border-slate-100 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between px-5 md:px-6 py-4 border-b border-slate-100">
          <div className="flex items-center">
            {icon && (
              <div className="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center mr-3 text-red-600">
                {icon}
              </div>
            )}
            <div>
              {title && <h3 className="text-lg font-bold text-slate-900">{title}</h3>}
              {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
            </div>
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={padding ? 'p-5 md:p-6' : ''}>{children}</div>
    </div>
  );
};

export default Card;
